import { Button, Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';

const HostButtonComponent: React.FC<any> = ({ host, isValidHost, addNewHost }: any) => {
    const { t } = useTranslation();
    return (
        <Grid item xs={3}>
            <Button
                sx={{ mt: 1, width: '100%' }}
                variant="contained"
                disabled={!isValidHost || host.length <= 0}
                onClick={addNewHost}
            >
                {t('addHostButton')}
            </Button>
        </Grid>
    );
};

export default HostButtonComponent;
